"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckDepositLimitReached = void 0;
var react_1 = require("react");
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var useCheckDepositLimitReached = function () {
    var data = (0, swr_hooks_1.useDepositLimit)().data;
    var router = (0, navigation_1.useRouter)();
    var coolingOffLimit = (0, swr_hooks_1.useCoolingOffLimit)().data;
    var coolingOffActiveModalLink = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.COOLING_OFF_ACTIVE);
    var depositReachedModalLink = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.DEPOSIT_REACHED);
    var searchParams = (0, navigation_1.useSearchParams)();
    var isCoolingOffActiveOpen = searchParams.get('modal') === apps_shared_1.POPUP_CONSTANTS.COOLING_OFF_ACTIVE;
    var isDepositReachedOpen = searchParams.get('modal') === apps_shared_1.POPUP_CONSTANTS.DEPOSIT_REACHED;
    return (0, react_1.useCallback)(function () {
        if (coolingOffLimit && !isCoolingOffActiveOpen) {
            return {
                isReached: true,
                redirect: function () { return router.replace(coolingOffActiveModalLink); },
            };
        }
        if (!coolingOffLimit &&
            !isCoolingOffActiveOpen &&
            (data === null || data === void 0 ? void 0 : data.reached) &&
            !isDepositReachedOpen) {
            return {
                isReached: true,
                redirect: function () { return router.replace(depositReachedModalLink); },
            };
        }
    }, [
        router,
        coolingOffLimit,
        isCoolingOffActiveOpen,
        coolingOffActiveModalLink,
        data === null || data === void 0 ? void 0 : data.reached,
        isDepositReachedOpen,
        depositReachedModalLink,
    ]);
};
exports.useCheckDepositLimitReached = useCheckDepositLimitReached;
